module.exports = __webpack_public_path__ + "static/img/7.3412ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/7.png
// module id = xxkX
// module chunks = 0